import { RestClient } from "clients/rest";

export type B000020FindRequest = Partial<{
  kengenId: string;
}>;

export type B000020FindResponse = {
  kengenId: string;
  gamenId: string;
  parameter: string;
  eigyosyoKengen: string;
};

export const B000020Find = (props: B000020FindRequest) => {
  return RestClient.get<B000020FindResponse[]>("b000020/find", {
    params: props,
  });
};
